















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class HelloWorld extends Vue {

  @Prop() private label!: string;

    public sports = ['Acondicionamiento Fisico','Gimnasia Artistica','Futsal', 'Futbol','Baloncesto','Voleibol'];
    public mdFielClass = ''; //'md-invalid'
    public mdInputText = '';
    public hasTyped = false;



 /* eslint-disable */
  public onChange($event: any): void {
      this.hasTyped = true;
      this.$emit('onChange', this.mdInputText)
  }

  public get mdFieldClass(){
      return (this.mdInputText || !this.hasTyped) ? '' : 'md-invalid';
  }


}
